import { match } from "ts-pattern";

import AddStepperStepTitleCardComponent from "@/components/Stepper/AddStepperStepTitleCard";
import { defaultNS, useTranslation } from "@/lib/i18n";

import type { IMPORT_CSV_FORM_HASH_VALUE } from "../-constants/hash";
import { IMPORT_CSV_FORM_HASH } from "../-constants/hash";

type Props = {
  hash: string;
};

const AddStepperStepTitleCard = ({ hash }: Props) => {
  const { t } = useTranslation(defaultNS, {
    keyPrefix: "pages.person.importCsv.titleCard",
  });

  const stepName = match(hash as IMPORT_CSV_FORM_HASH_VALUE)
    .with(IMPORT_CSV_FORM_HASH.UPLOAD_FILE, () => t("title.step1"))
    .with(IMPORT_CSV_FORM_HASH.PREVIEW_FILE, () => t("title.step2"))
    .with(IMPORT_CSV_FORM_HASH.IMPORT_DATA, () => t("title.step3"))
    .otherwise(() => t("title.step1"));

  return <AddStepperStepTitleCardComponent stepName={stepName} />;
};

export default AddStepperStepTitleCard;
